import React from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import { RemoveRounded, AddRounded } from '@mui/icons-material';
import { radius } from '../../theme';

// One shared numeric stepper (two IconButtons + a centered field) —
// replaces the 3 independent builds that used to live in FoodDialog,
// FoodDialogOwnAdded, and Profile's own NumberStepper.
export default function QuantityStepper({
  value,
  onChange,
  min = 0,
  max = 9999,
  step = 1,
  size = 44,
  fieldWidth = 80,
  fontSize = '1.25rem',
  gap = 1.5,
}) {
  const clamp = (v) => Math.min(max, Math.max(min, v));

  const handleInputChange = (e) => {
    const raw = e.target.value;
    if (raw === '') {
      onChange('');
      return;
    }
    const num = Number(raw);
    if (!Number.isNaN(num)) onChange(num);
  };

  const buttonSx = {
    border: 1,
    borderColor: 'divider',
    borderRadius: radius.lg,
    width: size,
    height: size,
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap }}>
      <IconButton sx={buttonSx} onClick={() => onChange(clamp((value || 0) - step))}>
        <RemoveRounded />
      </IconButton>
      <TextField
        value={value}
        onChange={handleInputChange}
        onFocus={(e) => e.target.select()}
        variant="standard"
        inputProps={{
          inputMode: 'decimal',
          style: { textAlign: 'center', fontWeight: 700, fontSize },
        }}
        sx={{ width: fieldWidth }}
      />
      <IconButton sx={buttonSx} onClick={() => onChange(clamp((value || 0) + step))}>
        <AddRounded />
      </IconButton>
    </Box>
  );
}
